import styled from 'styled-components';
import { respondTo } from 'components/styles/_respondTo';

export const Wrapper = styled.div`
  display: flex;
  padding: ${({ mobPadding }) => mobPadding || '20px 0'};
  justify-content: center;
  margin-top: 20px;
  width: 100%;
  ${respondTo.desktop`
    padding: 20px;
    justify-content: flex-end;
  `}
`;
